import React from 'react';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
import { useAppContext } from '../context/AppContext';
import { translations } from '../translations/translations';
import SectionWrapper, { SectionHeader } from '../components/SectionWrapper';
import { fadeUp } from '../motion/presets';
import '../styles/About.css';

export default function About() {
    const { language } = useAppContext();
    const t = translations[language];

    return (
        <SectionWrapper id="about" className="about">
            <SectionHeader label={t.about.label} title={t.about.title} />

            <div className="about__grid">
                <motion.div className="about__text" variants={fadeUp}>
                    <p className="about__description">{t.about.description}</p>
                    <a
                        href={`${process.env.PUBLIC_URL}/CV/Mert_Ozkaya_CV.pdf`}
                        download
                        className="about__cv-link"
                    >
                        <Download size={16} />
                        <span>{t.about.downloadCV}</span>
                    </a>
                </motion.div>

                <motion.div className="about__skills" variants={fadeUp}>
                    <h3 className="about__skills-title">Tech Stack</h3>
                    <div className="about__skill-tags">
                        {t.about.skills.map((skill) => (
                            <span key={skill} className="about__tag">
                                {skill}
                            </span>
                        ))}
                    </div>
                </motion.div>
            </div>
        </SectionWrapper>
    );
}
